import { CalculateOutlined, CalendarMonthOutlined } from '@mui/icons-material';

const defaultFieldsResolver = (collection, t) => {
  switch (collection) {
    case 'contacts':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },
      ];
    case 'cardsinvoiced':
    case 'cardsuninvoiced':
    case 'cardsexpense':
      return [
        {
          name: t('invoiceDate'),
          value: 'invoiceDate',
          typeData: 'date',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('dueDate'),
          value: 'dueDate',
          typeData: 'date',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },
        {
          name: t('subtotal'),
          value: 'financesSubtotal',
          typeData: 'number',
          icon: <CalculateOutlined />,
        },
        {
          name: t('total'),
          value: 'financesTotal',
          typeData: 'number',
          icon: <CalculateOutlined />,
        },
        {
          name: t('balance'),
          value: 'financesBalance',
          typeData: 'number',
          icon: <CalculateOutlined />,
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'profiles':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },
        {
          name: 'Type',
          value: 'type',
          typeData: 'text',
        },
        {
          name: t('attributes'),
          value: 'targetProfileAttributes',
          typeData: 'text',
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'services':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'articles':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'nodies':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },

        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'grids':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'tasks':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'storages':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'passes':
      return [
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: 'Notes',
          value: 'note',
          allowSub: false,
          typeData: 'html',
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
      ];
    case 'payments':
      return [
        {
          name: t('targetName'),
          value: 'targetId',
          allowSub: false,
          typeData: 'search',
        },
        {
          name: t('name'),
          value: 'name',
          allowSub: false,
          typeData: 'text',
        },
        {
          name: t('tags'),
          value: 'tags',
          allowSub: false,
          typeData: 'tags',
        },
        {
          name: t('lastUpdate'),
          value: 'lastUpdate',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
        {
          name: t('timeStamp'),
          value: 'timeStamp',
          typeData: 'date-time',
          icon: <CalendarMonthOutlined />,
        },
      ];
    default:
      return [];
  }
};

export default defaultFieldsResolver;
